import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';

// Components.
import UpgradeIcon from 'components/Icons/Menu/UpgradeIcon';
import DashboardIcon from 'components/Icons/Menu/DashboardIcon';
import DataSourcesIcon from 'components/Icons/Menu/DataSourcesIcon';
import PaymentIcon from 'components/Icons/Menu/PaymentIcon';
import LMSIcon from 'components/Icons/Menu/LMSIcon';
import UserProfileIcon from 'components/Icons/Menu/UserProfileIcon';
import LogoutIcon from 'components/Icons/Menu/LogoutIcon';
import HelpIcon from 'components/Icons/Menu/HelpIcon';

// Utils.
import { isFreeUser, isWebviewApp, isMobile } from 'utils';

// Styles.
import styles from './styles.module.scss';

export default class HeaderMenuAdditionalItems extends PureComponent {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isShow !== nextProps.isShow) {
      document.body.classList.toggle('welltory-noscroll', nextProps.isShow);
    }
  }

  onClickAdditionalMenuItem = () => {
    this.props.onClickAdditionalMenuItem();
  };

  onClickHelpMenuItem = () => {
    window.open('https://help.welltory.com/', '_blank');
  };

  render() {
    const { userState, isAuthenticated, locationPath, payConnectedPackages } = this.props;
    const isFreeUserStatus = isFreeUser(userState);
    window.location.origin.includes('stage') ?
      window.location.origin.replace('-app', '-monocle') :
      window.location.origin;
    const to = `${origin}/profile/payment-method`;

    return (
      <div>
        <div className={styles.additionalMenuItemsMobile}>
          {(isAuthenticated && isFreeUserStatus) &&
            <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
              <LinkContainer to="/payment">
                <MenuItem className={styles.userMenuLink}>
                  <div className={styles.userMenuLinkIcon}>
                    <UpgradeIcon/>
                  </div>
                  <span>{I18n.t('Upgrade')}</span>
                </MenuItem>
              </LinkContainer>
            </div>
          }
          {isAuthenticated && (
            <>
              <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
                <LinkContainer to="/dashboard">
                  <MenuItem className={styles.userMenuLink}>
                    <div className={styles.userMenuLinkIcon}>
                      <DashboardIcon isActive={locationPath.indexOf('dashboard') !== -1} />
                    </div>
                    <span>Dashboard</span>
                  </MenuItem>
                </LinkContainer>
              </div>
              <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
                <LinkContainer to="/lms">
                  <MenuItem className={styles.userMenuLink}>
                    <div className={styles.userMenuLinkIcon}>
                      <LMSIcon isActive={locationPath.indexOf('lms') !== -1} />
                    </div>
                    <span>Academy</span>
                  </MenuItem>
                </LinkContainer>
              </div>
            </>
          )}
        </div>
        {isAuthenticated &&
          <div className={cx(styles.userMenuLinkWrapper, styles.userMenuLinkWrapperMainMobile)} onClick={this.onClickAdditionalMenuItem}>
            <LinkContainer to="/user/profile">
              <MenuItem className={styles.userMenuLink}>
                <div className={styles.userMenuLinkIcon}>
                  <UserProfileIcon isActive={locationPath.indexOf('user/profile') !== -1}/>
                </div>
                <span>{I18n.t('Profile')}</span>
              </MenuItem>
            </LinkContainer>
          </div>
        }
        {(isAuthenticated && locationPath.indexOf('user/') !== -1) &&
          <div className={cx(styles.userMenuLinkWrapper, styles.userMenuLinkWrapperMobile)} onClick={this.onClickAdditionalMenuItem}>
            <LinkContainer to="/user/personal">
              <MenuItem className={styles.userMenuLink}>
                <span>{I18n.t('Personal data')}</span>
              </MenuItem>
            </LinkContainer>
          </div>
        }
        {(isAuthenticated && locationPath.indexOf('user/') !== -1) &&
          <div className={cx(styles.userMenuLinkWrapper, styles.userMenuLinkWrapperMobile)} onClick={this.onClickAdditionalMenuItem}>
            <LinkContainer to="/user/units">
              <MenuItem className={styles.userMenuLink}>
                <span>{I18n.t('Units')}</span>
              </MenuItem>
            </LinkContainer>
          </div>
        }
        {isAuthenticated &&
          <div className={cx(styles.userMenuLinkWrapper, styles.userMenuLinkWrapperMainMobile)} onClick={this.onClickAdditionalMenuItem}>
            <LinkContainer to="/payment-history">
              <MenuItem className={styles.userMenuLink}>
                <div className={styles.userMenuLinkIcon}>
                  <PaymentIcon isActive={locationPath.indexOf('payment') !== -1}/>
                </div>
                <span>{I18n.t('Payments')}</span>
              </MenuItem>
            </LinkContainer>
          </div>
        }
        {((isAuthenticated && locationPath.indexOf('payment') !== -1) && payConnectedPackages.isFetched === true && payConnectedPackages.payConnectedPackages.length !== 0 && payConnectedPackages.payConnectedPackages[0].card !== null) &&
          <div className={cx(styles.userMenuLinkWrapper, styles.userMenuLinkWrapperMobile)} onClick={this.onClickAdditionalMenuItem}>
            <a href={to}>
              <MenuItem className={styles.userMenuLink}>
                <span
                >
                  {I18n.t('Payment method')}
                </span>
              </MenuItem>
            </a>
          </div>
        }
        {(isAuthenticated && locationPath.indexOf('payment') !== -1) &&
          <div className={cx(styles.userMenuLinkWrapper, styles.userMenuLinkWrapperMobile)} onClick={this.onClickAdditionalMenuItem}>
            <LinkContainer to="/payment-history">
              <MenuItem className={styles.userMenuLink}>
                <span>{I18n.t('Transaction history')}</span>
              </MenuItem>
            </LinkContainer>
          </div>
        }
        {isAuthenticated &&
          <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
            <MenuItem onClick={this.onClickHelpMenuItem} className={styles.userMenuLink}>
              <div className={styles.userMenuLinkIcon}>
                <HelpIcon/>
              </div>
              <span>{I18n.t('Help')}</span>
            </MenuItem>
          </div>
        }
        {(!isAuthenticated && isMobile() && !isWebviewApp()) &&
          <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
            <a href={`/auth/signin/?destination=${window.location.pathname}`} className={styles.menuLink}>
              {I18n.t('Sign in')}
            </a>
          </div>
        }
        {(!isAuthenticated && isMobile() && !isWebviewApp()) &&
          <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
            <a href="/auth/registration/" className={styles.menuLink}>
              {I18n.t('Sign up')}
            </a>
          </div>
        }
        {(isAuthenticated && !isWebviewApp()) &&
          <div className={styles.userMenuLinkWrapper} onClick={this.onClickAdditionalMenuItem}>
            <LinkContainer to="/user/logout">
              <MenuItem className={styles.userMenuLink}>
                <div className={styles.userMenuLinkIcon}>
                  <LogoutIcon />
                </div>
                <span>{I18n.t('Log out')}</span>
              </MenuItem>
            </LinkContainer>
          </div>
        }
      </div>
    );
  }

}
